'use strict';

const youtubeId = url => {
	if (!url) return '';
	const m = String(url).match(
		/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/))([A-Za-z0-9_-]{6,})/
	);
	return m ? m[1] : '';
};

const vimeoId = url => {
	if (!url) return '';
	const m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)/);
	return m ? m[1] : '';
};

const isDirectFile = url =>
	/\.(mp3|wav|ogg|flac|m4a|aac|mp4|webm|ogv)(\?|#|$)/i.test(String(url || ''))
	|| String(url || '').indexOf('/api/content/') === 0;

module.exports = {youtubeId, vimeoId, isDirectFile};
